// extracted by mini-css-extract-plugin
export default {"root":"NGcdNLlWhkxAdvbuRAdy","right":"CvYGp0jhUO0APnM3nrrw","text":"_iwMQpeGa7H3idC6MYEp"};